import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Departement } from "../core/model/departement";
import { DepartementService } from "../core/service/departement.service";
import { EditDepartementComponent } from "./edit-departement/edit-departement.component";
import { AddDepartementComponent } from "./add-departement/add-departement.component";

@Component({
  selector: "app-departement",
  templateUrl: "./departement.component.html",
  styleUrls: ["./departement.component.scss"],
})
export class DepartementComponent implements OnInit {
  departements: Departement[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _departementService: DepartementService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.spinner.hide();
    this.getDepartements();
  }

  getDepartements() {
    this._departementService.getAllDepartements().subscribe(
      (data) => {
        this.departements = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      },
      (error) => {
        console.log(error);
      }
    );
  }

  edit(departement: Departement): void {
    const modalRef = this.modalService.open(EditDepartementComponent, {
      centered: true,
    });
    modalRef.componentInstance.departement = departement;

    modalRef.result.then(
      (updated: Departement) => {
        this.spinner.hide();
        if (updated && this.departements) {
          const index = this.departements.findIndex((d) => d.id == updated.id);
          if (index !== -1) {
            this.departements[index] = updated;
            this.departements = [...this.departements];
            return;
          }
        }
        this.getDepartements();
      },
      () => {
        this.spinner.hide();
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddDepartementComponent, {
      centered: true,
    });

    modalRef.result.then(
      () => {
        this.spinner.hide();
        this.getDepartements();
      },
      () => {
        this.spinner.hide();
      }
    );
  }
}
